"use strict";

var Shim = require("./shim");
var FastSet = require("./_fast-set");
var PropertyChanges = require("./listen/property-changes");

module.exports = FastSet;

Object.addEach(FastSet.prototype, PropertyChanges.prototype);



//////////////////
// WEBPACK FOOTER
// ./node_modules/collections/fast-set.js
// module id = 685
// module chunks = 0